<template>
  <div class="mc-scheduler-digest-preview">
    <h4 class="my-3">
      {{ $t('dashboard.scheduler.action.preview') }}
    </h4>
    <b-card class="border">
      <b-card-title>{{ title }}</b-card-title>
      <b-card-body class="p-0 my-3">
        <p>{{ content }}</p>
        <template v-if="selectedContent == '0'">
          <component :is="currentPreview" />
        </template>
        <template v-else>
          <div class="mc-scheduler-digest-preview__metabase">
            <MetabaseContent
              v-if="!loading"
              :id="dataContent.content_id"
              :link="dataContent.embed_link"
            />
          </div>
        </template>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import Daily from '../Email/Daily'
import Weekly from '../Email/Weekly'
import Monthly from '../Email/Monthly'
import MetabaseContent from './MetabaseContent'

export default {
  components: {
    Daily,
    Weekly,
    Monthly,
    MetabaseContent,
  },
  props: {
    period: {
      type: String,
      default: 'm',
    },
    selectedContent: {
      type: String,
      default: '0',
    },
    dataContent: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPreview() {
      switch (this.period) {
        case 'd':
          return 'Daily'
        case 'w':
          return 'Weekly'
        case 'm':
          return 'Monthly'
        default:
          return 'Monthly'
      }
    },
  },
}
</script>
